import * as httpCodes from '../../common/httpStatusCodes';
import * as GeneralActionTypes from '../../common/actionTypes';
import * as ActionTypes from './actionTypes';
import apiActionCreator from '../../common/service/api/actionCreator';
import {buildErrorMessage} from '../../common/util/errorUtils';

const handleErrorMessage = (error) => {
  const {status} = error;

  if (status === httpCodes.HTTP_400_BAD_REQUEST) {
    return {'type': GeneralActionTypes.Forms.DO_NOT_SHOW_MESSAGE};
  }
  return buildErrorMessage(error);
};


export const getPriceFactorAndFobByPartNo = (partno) => apiActionCreator({
  'endpoint': `/parts/part-quotation-info/${partno}`,
  'authenticated': true,
  'types': [
    ActionTypes.FETCH_PART_PRICE_INFO_REQUEST,
    ActionTypes.FETCH_PART_PRICE_INFO_SUCCESS,
    [
      ActionTypes.FETCH_PART_PRICE_INFO_FAILED,
      (error) => handleErrorMessage(error),
    ],
  ],
  'microservice': 'part',
  'method': 'GET',
});

export const clearPriceFactorAndFob = () => ({
  'type': ActionTypes.CLEAR_PRICE_AND_FOB,
});
